<template>
  <div class="stepCardWrapper">
    <div class="row justify-content-left align-items-center">
      <div class="col-xs-9 col-sm-6 col-lg-8">
        <div class="descriptionText" v-html="descriptionText"></div>
        <div class="stepsWrapper">
          <template v-for="(step,idx) in steps">
            <div v-if="idx%2 == 0" :key="idx" class="step d-flex flex-row align-items-center">
              <div>
                <div class="circle">{{step.label}}</div>
              </div>
              <div class="text">{{step.text}}</div>
            </div>
            <div v-else :key="idx" class="step d-flex flex-row align-items-center">
              <div>
                <div class="circle">{{step.label}}</div>
              </div>
              <div class="text">{{step.text}}</div>
            </div>
          </template>
        </div>
      </div>
      <div class="col-xs-3 col-sm-6 col-lg-3">
        <img
          class="stepImage"
          src="https://jolt-assets.s3.eu-central-1.amazonaws.com/template/receipt_sample.png"
        />
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "receipt-information",
  props: {
    descriptionText: {
      required: false,
      type: String,
      default: ""
    },
    steps: {
      required: false,
      type: [Array, Object],
      default: () => []
    }
  }
};
</script>
<style lang="scss" scoped>
.stepImage img {
  height: 175px;
  width: 175px;
  border-radius: 50%;
}

.circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  background: #7c7c7c;
  margin-top: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: bold;

  font-size: 12px;
  line-height: 25px;
}
.text {
  padding: 5px;
}
.stepsWrapper {
  margin: 10px 0;
  padding: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  max-width: 700px;
  .step {
    width: 250px;
    padding: 5px;
  }
}
</style>